import { Ecoulement } from './ecoulement.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationEcoulement {
    static jsonMap = {
        idRefCampagne: { key: 'idRefCampagne', optional: true },
        idEntreprise: { key: 'idEntreprise', optional: true },
        numMois: { key: 'numMois', optional: true },
        ecoulements: { key: 'ecoulements', converter: new (ArrayClassConverterFactory.build(Ecoulement))(), default: () => [] }
    };

    public idRefCampagne: number;
    public idEntreprise: number;
    public numMois: number;
    public ecoulements: Ecoulement[];
}
